<template>
  <SearchYearName :title="'Comissões de Festa'" :minYear="1981" :directory="'comissoes_festa'" />
</template>

<script>
import SearchYearName from '@/components/SearchYearName.vue';

export default {
  components: {
    SearchYearName
  }
};
</script>

<style>
</style>
